<script>
	import PageSection from "../../components/PageSection.svelte";
	import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
	import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	import { registerFormStart } from "../../tealium";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let lastVisitedPage = null;
	export let persistUrl = null;
	export let title = null;

	pageNumber.update((p) => pageIndex);
	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	//  Get the user Agent
	$model.UserAgent = navigator.userAgent;
	$model.referrer = document.referrer;
	$model.RegistrationSegmentId = null;
</script>

<PageSection>
	<div class="row justify-content-center">
		<div class="col-md-8 col-sm-12">
			<h1 class="text-center">Register for the {projectSettings.classActionName}</h1>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<p></p>
			<p>
				You are eligible to sign up to the Sun Princess Norovirus Class Action if you were a passenger on one of
				the following Sun Princess voyages – regardless of whether or not you fell ill:<br />
			</p>
			<ul>
				<li>Fremantle, 5 December 2016 to 18 December 2016 (S622P)</li>
				<li>Margaret River, 18 December 2016 to 21 December 2016 (S623)</li>
				<li>Indonesia, 21 December 2016 to 5 January 2017 (S701)</li>
				<li>Margaret River, 5 January 2017 to 8 January 2017 (S702)</li>
				<li>Northern Australia, 8 January 2017 to 22 January 2017 (S703)</li>
				<li>Papua New Guinea, 22 January 2017 to 2 February 2017 (S704)</li>
				<li>New Zealand, 2 February 2017 to 16 February 2017 (S705)</li>
				<li>South Pacific, 16 February 2017 to 26 February 2017 (S706)</li>
			</ul>
			<p>
				To register on a confidential, no-cost, no-obligation basis, please complete the following registration
				form.
			</p>
		</div>
	</div>
	<div class="row justify-content-md-center register-btn">
		<div class="col-md-8 col-sm-12 text-center">
			<NavigationButtons
				{persistUrl}
				showPrevious="false"
				{nextPage}
				nextPageLabel="REGISTER"
				verifyCaptcha="true"
				pageName={title}
				tealiumTag={false}
				onNext={() => registerFormStart()}
			></NavigationButtons>
		</div>
	</div>
	<div class="row justify-content-md-center">
		<div class="col-md-8 col-sm-12">
			<p>
				If you are in any doubt about whether you need to complete this form, or whether you have suffered
				damages, please contact Shine Lawyers on
				<ClassActionPhoneNumber></ClassActionPhoneNumber> or via email to
				<ClassActionEmailAddress></ClassActionEmailAddress>.
			</p>
		</div>
	</div>
</PageSection>

<style>
	h1 {
		margin-bottom: 20px;
	}

	h2 {
		font-size: 1.1em;
		margin-bottom: 16px;
		font-weight: 700;
	}

	a {
		text-decoration: none;
	}

	a:hover {
		text-decoration: underline;
	}

	.register-btn {
		margin-bottom: 20px;
	}
</style>
